// Controlled industry vocabulary so benchmark cohorts match consistently.
export const INDUSTRIES = [
  "Retail – General",
  "Supermarket & Grocery",
  "Fashion & Apparel",
  "Electronics & Appliances",
  "Food & Beverage / QSR",
  "Restaurants & Cafés",
  "Hospitality & Hotels",
  "Banking & Financial Services",
  "Telecommunications",
  "Healthcare & Pharmacy",
  "Automotive & Dealerships",
  "Beauty & Personal Care",
  "Fuel & Convenience",
  "Fitness & Wellness",
  "Travel & Leisure",
  "Logistics & Delivery",
  "Professional Services",
  "Public Sector & Government",
  "Other",
];
